export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTO_AUTH_REQUEST = "AUTO_AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const SET_SCHOOL_YEAR = "SET_SCHOOL_YEAR";
export const SET_STUDENT_INFO = "SET_STUDENT_INFO";
export const GET_ACCESS_CODE = "GET_ACCESS_CODE ";
export const AUTO_GET_ACCESS_CODE = "AUTO_GET_ACCESS_CODE ";